<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('mdfeTranslate.batchImportEmails')"
      :visible.sync="importEmailDialog"
      width="500px"
      @close="handleAddCusTimeDialog"
    >
      <el-button
        size="small" type="primary" @click="triggerFileInput"
      >{{ $t('customerManagements.clickUpload') }}
      </el-button>
      <input
        ref="referenceUpload"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style="display: none"
        type="file"
        @change="uploadFile($event)"
      >
      <div style="margin-top: 20px">
        <span class="downModule" @click="downLoadFile">{{
          $t('orderCenterCont.DownloadTemplate')
        }}</span>
        <span style="font-size: 12px; color: red">{{
          $t('customerManagements.pleaseUploadLI')
        }}</span>
      </div>
      <div v-if="fileName" class="downLink">
        <div>{{ fileName }}</div>
        <div><i class="el-icon-error" @click="delFile" /></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button
          size="small" type="primary" @click="cusSubmit(2)"
        >{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { providerGetModule, providerImportData } from '@/api/SupplierMain.js';

export default {
  data() {
    return {
      importEmailDialog: false,
      ruleForm: {
        effectiveTime: '',
        timeframeStartingPoint: '',
        agingType: 0,
        merchantId: ''
      },
      fileName: '',
      fileData: null,
      defaultTime: '',
      sizeFile: '',
      isSelect: false
    };
  },
  methods: {
    importEmailDialogFun() {
      this.importEmailDialog = true;
    },
    triggerFileInput() {
      this.$refs.referenceUpload.click();
    },
    // 上传文件
    uploadFile(e) {
      console.log(e, 'LKLK');
      this.fileData = e.target.files[0];
      this.fileName = e.target.files[0].name;
      this.sizeFile = e.target.files[0].size;
    },
    // 点击确定
    cusSubmit(val) {
      if (val === 1) {
        this.importEmailDialog = false;
        this.handleAddCusTimeDialog();
      } else {
        // 如果有文件上传
        if (this.fileName) {
          const formData = new FormData();
          formData.append('sizeFile', this.sizeFile);
          formData.append('file', this.fileData, this.fileName);
          formData.append('fileName', this.fileName);
          providerImportData(formData).then((res) => {
            if (res.code === 200) {
              this.importEmailDialog = false;
              this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
              this.$emit('emailSearch');
            }
          });
        } else {
          this.$message.error(this.$t('mdfeTranslate.uploadEmailFile'));
          return;
        }
      }
    },
    downLoadFile() {
      providerGetModule().then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        const fileName = this.$t('mdfeTranslate.reconciliationEmailTemplate');
        link.href = url;
        link.setAttribute('download', `${fileName}`); // 更改为实际的文件名和扩展名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理 URL
      });
    },
    // 删除文件
    delFile() {
      this.fileName = '';
      this.fileData = null;
      this.sizeFile = '';
    },
    handleAddCusTimeDialog() {
      this.fileName = '';
      this.fileData = null;
      this.$refs.referenceUpload.value = '';
      this.$refs.ruleForm.resetFields();
      this.isSelect = false;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #00A551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}
</style>
